export const projectsObjA = {
    id:'projects-section-data',
    title:'My Projects Of Interest',
    cardContentTitle:'Antelope Classifier',
    cardContentBody:'After training a machine learning model you need to deploy it to show potential stakeholders what the results would look like With a decent UI, not jupyter notebook sto achieve any sort of buyback from the people/business that potentially want and can pay for this type of service.',
    cardActionsText:'Read More',
    cardActionsTextX:'Try Out the App',
    img:'https://d3q0oijmiduzg2.cloudfront.net/rubanzasilver/antelopes.jpeg',
    alt:'Antelope Classfier Project',
    cardContentTitleE:'Classification with the Academic Success dataset',
    cardContentBodyE:'A classification model to predict students dropout and academic success rate.  ',
    cardActionsTextE:'Read Notebook solution',
    cardActionsTextEA:'Read solution write up',
    imgE:'https://d3q0oijmiduzg2.cloudfront.net/rubanzasilver/academic_success.jpg',
    altE:'Machine learning model to predict the academic success rate of students',
    cardContentTitleA:'Personal Website',
    cardContentBodyA:'This website is built with reactjs.Follow the link below to check out the documentation.  ',
    cardActionsTextA:'See Code',
    imgA:'https://d3q0oijmiduzg2.cloudfront.net/rubanzasilver/silverPotraitCompressed.webp',
    altA:'Rubanza Silver Personal website',
    cardContentTitleB:'Zigoti Coffee Website',
    cardContentBodyB:'  Zigoti Coffee is a Ugandan coffee house that covers the whole value chain from growing, buying, processing, roasting, and export of Ugandan Coffee beans.',
    cardActionsTextB:'Visit Zicofe.com',
    imgB:'https://d3q0oijmiduzg2.cloudfront.net/rubanzasilver/ZICOFE.JPG',
    altB:'Zicofe.com',
    cardContentTitleC:'Suwik Investments Website',
    cardContentBodyC:'Suwik aims to be the leading exporter of the freshest, highest quality agricultural products with guaranteed customer satisfaction',
    cardActionsTextC:'Visit Site',
    cardActionsTextD:'See Code',
    imgC:'https://d322abd807wvow.cloudfront.net/suwik-photos/suwikLogo.jpeg',
    altC:'Antelope Classfier Project',

    cardContentTitleX:'Regression - Prediction of Used Car Prices',
    cardContentBodyX:'A regression model to predict the price of used cars based on various attributes',
    cardActionsTextXA:'Read notebook solution',
    cardActionsTextXB:'Read solution write up',
    imgX:'https://d3q0oijmiduzg2.cloudfront.net/rubanzasilver/used_cars.jpg',
    altX:'Binary Classification of Insurance Cross Selling',

    cardContentTitleY:'Binary Prediction of Poisonous Mushrooms',
    cardContentBodyY:'A classification model to predict whether a mushroom is edible or poisonous based on its physical characteristics.',
    cardActionsTextY:'Read notebook solution',
    imgY:'https://d3q0oijmiduzg2.cloudfront.net/rubanzasilver/mushroomAnatomy.jpg',
    altY:'Binary Prediction of Poisonous Mushrooms',

    cardContentTitleZ:'Binary Classification of Insurance Cross Selling',
    cardContentBodyZ:'A classification model to predict which customers respond positively to an automobile insurance offer.',
    cardActionsTextZ:'Read notebook solution',
    imgZ:'https://d3q0oijmiduzg2.cloudfront.net/rubanzasilver/insuarance_pexels.jpg',
    altZ:'Binary Classification of Insurance Cross Selling',

    cardContentTitleF:'ML/AI model serving and deployment with BentoML',
    cardContentBodyF:'Serving and deploying a binary classification machine learning model using BentoML',
    cardActionsTextF:'Read More',
    imgF:'https://d3q0oijmiduzg2.cloudfront.net/rubanzasilver/dalle_deployment.webp',
    altF:'ML model deployment with BentoML',

    
};


export const projectsObjB = {
    id:'projects-section-data',
    title:'',
    cardContentTitle:'Suwik Investments Website',
    cardContentBody:'Suwik aims to be the leading exporter of the freshest, highest quality agricultural products with guaranteed customer satisfaction',
    cardActionsText:'Visit Site',
    cardActionsTextX:'See Code',
    img:'https://d3q0oijmiduzg2.cloudfront.net/rubanzasilver/antelopes.jpeg',
    alt:'Antelope Classfier Project',
    cardContentTitleA:'Personal Website',
    cardContentBodyA:'This website is built with reactjs.Follow the link below to check out the documentation.  ',
    cardActionsTextA:'See Code',
    imgA:'https://d3q0oijmiduzg2.cloudfront.net/rubanzasilver/faceShot.jpg',
    altA:'Rubanza Silver Personal website',
    cardContentTitleB:'Zigoti Coffee Website',
    cardContentBodyB:'  Zigoti Coffee is a Ugandan coffee house that covers the whole value chain from growing, buying, processing, roasting, and export of Ugandan Coffee beans.',
    cardActionsTextB:'Visit Zicofe.com',
    imgB:'https://d3q0oijmiduzg2.cloudfront.net/rubanzasilver/ZICOFE.JPG',
    altB:'Zicofe.com',
};